import React from "react";

const Landtlogo2 = () => {
  return (
    <div>
      <div>
        <img
          className="px-3 py-3"
          id="ps-1"
          src="Updated Logo 1.svg"
          alt=""
          style={{
            backgroundColor: "#EFF8FF",
            borderRadius: "20px",
            position: "absolute",
            left: "30%",
            top: "40%",
            height: "150px",
          }}
        />
      </div>
    </div>
  );
};

export default Landtlogo2;
